import React from 'react';
import { CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const CHECKOUT_BASE = 'https://pay.hotmart.com/O103704589E';
const CHECKOUT_PRO = 'https://pay.hotmart.com/Y104782550L';
function playPurchaseSound() {
  try {
    const ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
    const osc1 = ctx.createOscillator();
    const gain1 = ctx.createGain();
    osc1.type = 'sine';
    osc1.frequency.setValueAtTime(1200, ctx.currentTime);
    osc1.frequency.exponentialRampToValueAtTime(1800, ctx.currentTime + 0.08);
    gain1.gain.setValueAtTime(0.3, ctx.currentTime);
    gain1.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.3);
    osc1.connect(gain1);
    gain1.connect(ctx.destination);
    osc1.start(ctx.currentTime);
    osc1.stop(ctx.currentTime + 0.3);
    const osc2 = ctx.createOscillator();
    const gain2 = ctx.createGain();
    osc2.type = 'sine';
    osc2.frequency.setValueAtTime(1600, ctx.currentTime + 0.1);
    osc2.frequency.exponentialRampToValueAtTime(2200, ctx.currentTime + 0.18);
    gain2.gain.setValueAtTime(0, ctx.currentTime);
    gain2.gain.setValueAtTime(0.25, ctx.currentTime + 0.1);
    gain2.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.4);
    osc2.connect(gain2);
    gain2.connect(ctx.destination);
    osc2.start(ctx.currentTime + 0.1);
    osc2.stop(ctx.currentTime + 0.4);
  } catch (e) {}
}
function FeatureItem({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex items-start gap-2.5 text-left" data-id="element-281">
      <div className="bg-[#d4a017]/20 p-0.5 rounded-full flex-shrink-0 mt-1" data-id="element-282">
        <CheckIcon className="w-3.5 h-3.5 text-[#f0c040]" strokeWidth={3} data-id="element-283" />
      </div>
      <span className="text-gray-300 text-sm leading-snug" data-id="element-284">{children}</span>
    </div>;
}
export function PricingSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section id="pricing" className="bg-[#1a1a2e] text-white py-14 md:py-20 px-4 border-t border-white/5" data-id="element-285">
      <div className="container mx-auto max-w-5xl" data-id="element-286">
        {/* Header */}
        <div ref={ref1} className={`reveal text-center mb-4 md:mb-6 ${vis1 ? 'is-visible' : ''}`} data-id="element-287">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-serif font-bold mb-3 text-white leading-tight" data-id="element-288">
            Elegí tu nivel de formación en Reiki
          </h2>
          <p className="text-gray-400 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-3" data-id="element-289">
            No todos buscan lo mismo. Algunas personas quieren aprender Reiki
            para su crecimiento personal. Otras desean convertirlo en una
            herramienta profesional.
          </p>
          <p className="text-[#f0c040] font-serif font-semibold text-lg md:text-xl italic" data-id="element-290">
            Elegí el camino que hoy resuene con vos.
          </p>
        </div>

        {/* Motivational intro */}
        <div className="text-center max-w-2xl mx-auto mb-6 md:mb-8 space-y-3" data-id="element-291">
          <p className="text-[#f0c040] font-serif italic text-xl md:text-2xl" data-id="element-292">
            ✨ Puedes seguir buscando respuestas sueltas…
          </p>
          <p className="text-white font-serif font-semibold text-xl md:text-2xl" data-id="element-293">
            O puedes comenzar una formación real.
          </p>
          <p className="text-gray-300 text-lg md:text-xl leading-relaxed" data-id="element-294">
            Aprender Reiki.
            <br data-id="element-295" />
            Sanar tu vida.
            <br data-id="element-296" />Y quizás abrir una nueva etapa profesional.
          </p>
          <p className="text-[#f0c040] font-serif font-bold text-lg md:text-xl italic" data-id="element-297">
            El primer paso empieza aquí.
          </p>
        </div>

        {/* Pricing Cards */}
        <div ref={ref2} id="pricing-offer" style={{
        scrollMarginTop: '80px'
      }} className={`reveal grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-start ${vis2 ? 'is-visible' : ''}`} data-id="element-298">
          {/* COLUMN 1 — Formación Completa */}
          <div className="bg-[#1e1e30] rounded-2xl p-4 sm:p-8 border border-white/10 shadow-xl flex flex-col scale-[0.92] sm:scale-100 origin-top" data-id="element-299">
            <div className="text-center mb-4 sm:mb-6" data-id="element-300">
              <span className="text-green-400 text-xs font-bold tracking-[0.2em] uppercase mb-2 sm:mb-3 block" data-id="element-301">
                🟢 Formación Completa
              </span>
              <h3 className="text-xl sm:text-2xl md:text-3xl font-serif font-bold text-white mb-3 sm:mb-4" data-id="element-302">
                Curso Integral de Reiki
              </h3>
              <p className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white leading-none" data-id="element-303">
                $17.990
              </p>
              <p className="text-gray-500 text-sm line-through mt-1" data-id="element-304">$47.990</p>
              <p className="text-[#f0c040] font-bold text-xs sm:text-sm mt-1" data-id="element-305">
                💳 Hasta 3 cuotas sin interés
              </p>
            </div>

            <div className="space-y-2.5 sm:space-y-3 mb-4 sm:mb-6 flex-grow" data-id="element-306">
              <p className="text-gray-400 text-xs font-bold uppercase tracking-wider mb-2" data-id="element-307">
                Incluye:
              </p>
              <FeatureItem data-id="element-308">
                6 Tomos completos (Nivel 1, Nivel 2 y Maestría)
              </FeatureItem>
              <FeatureItem data-id="element-309">Formación paso a paso desde cero</FeatureItem>
              <FeatureItem data-id="element-310">Acceso inmediato y de por vida</FeatureItem>
              <FeatureItem data-id="element-311">Certificación digital</FeatureItem>
              <div className="pt-2" data-id="element-312">
                <p className="text-[#f0c040] font-bold text-sm" data-id="element-313">
                  🎁 + 3 Bonos especiales
                </p>
              </div>
            </div>

            <p className="text-gray-400 text-xs sm:text-sm text-center mb-4 sm:mb-6 leading-relaxed italic" data-id="element-314">
              Ideal si querés aprender Reiki para tu crecimiento personal y
              comenzar tu camino energético.
            </p>

            <a href={CHECKOUT_BASE} target="_blank" rel="noopener noreferrer" onClick={playPurchaseSound} className="w-full block py-3 sm:py-4 rounded-xl text-white font-bold text-sm sm:text-base sm:text-lg tracking-widest uppercase text-center transition-all shadow-[0_0_20px_rgba(34,197,94,0.3)] hover:shadow-[0_0_30px_rgba(34,197,94,0.5)] hover:-translate-y-1 bg-green-600 hover:bg-green-700 border border-green-500/50" style={{
            fontFamily: "'Cormorant Garamond', serif",
            letterSpacing: '0.08em'
          }} data-id="element-315">
              👉 QUIERO COMENZAR MI FORMACIÓN
            </a>
          </div>

          {/* COLUMN 2 — Formación Profesional */}
          <div className="relative bg-gradient-to-b from-[#1e1e30] to-[#252538] rounded-2xl p-6 sm:p-8 border-2 border-[#d4a017]/60 shadow-[0_0_60px_rgba(212,160,23,0.18),0_0_120px_rgba(212,160,23,0.06)] flex flex-col md:scale-[1.03] md:-my-3 ring-1 ring-[#d4a017]/20" data-id="element-316">
            {/* Animated glow background */}
            <div className="absolute -inset-[1px] rounded-2xl bg-gradient-to-b from-[#d4a017]/20 via-transparent to-[#d4a017]/10 pointer-events-none" data-id="element-317"></div>

            {/* Badge */}
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#d4a017] to-[#b8860b] text-[#0f0f1a] text-xs font-bold px-6 py-2 rounded-full shadow-[0_4px_20px_rgba(212,160,23,0.4)] z-10 whitespace-nowrap animate-pulse" data-id="element-318">
              🔥 MÁS ELEGIDO
            </div>

            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-2 border-l-2 border-[#d4a017]/40 rounded-tl-2xl pointer-events-none" data-id="element-319"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-2 border-r-2 border-[#d4a017]/40 rounded-br-2xl pointer-events-none" data-id="element-320"></div>

            <div className="relative text-center mb-6 pt-2" data-id="element-321">
              <span className="text-[#f0c040] text-xs font-bold tracking-[0.2em] uppercase mb-3 block" data-id="element-322">
                👑 Formación Profesional
              </span>
              <h3 className="text-2xl md:text-3xl font-serif font-bold text-white mb-4" data-id="element-323">
                Reiki Profesional Premium
              </h3>
              <p className="text-4xl md:text-5xl font-extrabold text-white leading-none" data-id="element-324">
                $27.990
              </p>
              <p className="text-gray-500 text-sm line-through mt-1" data-id="element-325">$75.990</p>
              <p className="text-[#f0c040] font-bold text-xs sm:text-sm mt-1" data-id="element-326">
                💳 Hasta 3 cuotas sin interés
              </p>
            </div>

            <div className="space-y-3 mb-4 flex-grow" data-id="element-327">
              <p className="text-gray-400 text-xs font-bold uppercase tracking-wider mb-2" data-id="element-328">
                Incluye todo lo anterior +
              </p>

              <div className="bg-[#d4a017]/10 border border-[#d4a017]/20 rounded-xl p-4 space-y-2.5 mb-3" data-id="element-329">
                <p className="text-[#f0c040] font-bold text-sm mb-2" data-id="element-330">
                  🎓 Especialización profesional
                </p>
                <div className="flex items-start gap-2 text-left" data-id="element-331">
                  <span className="text-base flex-shrink-0" data-id="element-332">📘</span>
                  <span className="text-gray-200 text-sm leading-snug" data-id="element-333">
                    Reflexología energética aplicada
                  </span>
                </div>
                <div className="flex items-start gap-2 text-left" data-id="element-334">
                  <span className="text-base flex-shrink-0" data-id="element-335">📗</span>
                  <span className="text-gray-200 text-sm leading-snug" data-id="element-336">
                    Cómo vivir del Reiki (sesiones y modelo profesional)
                  </span>
                </div>
                <div className="flex items-start gap-2 text-left" data-id="element-337">
                  <span className="text-base flex-shrink-0" data-id="element-338">📙</span>
                  <span className="text-gray-200 text-sm leading-snug" data-id="element-339">
                    Aromaterapia terapéutica para tratamientos energéticos
                  </span>
                </div>
              </div>

              <FeatureItem data-id="element-340">
                Formación completa Nivel 1, 2 y Maestría
              </FeatureItem>
              <FeatureItem data-id="element-341">3 Bonos incluidos</FeatureItem>
              <FeatureItem data-id="element-342">Certificación digital</FeatureItem>
              <FeatureItem data-id="element-343">Acceso de por vida</FeatureItem>
            </div>

            <p className="text-gray-400 text-sm text-center mb-6 leading-relaxed italic" data-id="element-344">
              Ideal si querés ofrecer sesiones, ampliar tus terapias o generar
              ingresos con Reiki.
            </p>

            <a href={CHECKOUT_PRO} target="_blank" rel="noopener noreferrer" onClick={playPurchaseSound} className="w-full block py-4 rounded-xl text-white font-bold text-base sm:text-lg tracking-widest uppercase text-center transition-all shadow-[0_0_30px_rgba(200,35,51,0.4)] hover:shadow-[0_0_40px_rgba(200,35,51,0.6)] hover:-translate-y-1 bg-[#c82333] hover:bg-[#bd2130] border border-red-500/50" style={{
            fontFamily: "'Cormorant Garamond', serif",
            letterSpacing: '0.08em'
          }} data-id="element-345">
              👉 QUIERO LA FORMACIÓN PROFESIONAL
            </a>
          </div>
        </div>

        {/* Comparison Table */}
        <div className="mt-10 md:mt-14 max-w-3xl mx-auto" data-id="element-346">
          <h3 className="text-xl md:text-2xl font-serif font-bold text-white text-center mb-6" data-id="element-347">
            📊 Comparativa de planes
          </h3>
          <div className="bg-[#1e1e30] rounded-2xl border border-white/10 overflow-hidden" data-id="element-348">
            <table className="w-full text-sm" data-id="element-349">
              <thead data-id="element-350">
                <tr className="border-b border-white/10" data-id="element-351">
                  <th className="text-left text-gray-400 font-medium py-3 px-4 md:px-6 w-1/2" data-id="element-352">
                    Característica
                  </th>
                  <th className="text-center text-green-400 font-bold py-3 px-2 md:px-4 w-1/4" data-id="element-353">
                    <span className="block text-xs tracking-wider uppercase" data-id="element-354">
                      Integral
                    </span>
                    <span className="text-white text-base" data-id="element-355">$17.990</span>
                  </th>
                  <th className="text-center text-[#f0c040] font-bold py-3 px-2 md:px-4 w-1/4 bg-[#d4a017]/5" data-id="element-356">
                    <span className="block text-xs tracking-wider uppercase" data-id="element-357">
                      Premium 👑
                    </span>
                    <span className="text-white text-base" data-id="element-358">$27.990</span>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/5" data-id="element-359">
                {[{
                feature: '6 Tomos completos (Nivel 1, 2 y Maestría)',
                base: true,
                pro: true
              }, {
                feature: 'Formación paso a paso desde cero',
                base: true,
                pro: true
              }, {
                feature: 'Acceso inmediato y de por vida',
                base: true,
                pro: true
              }, {
                feature: 'Certificación digital',
                base: true,
                pro: true
              }, {
                feature: '3 Bonos especiales',
                base: true,
                pro: true
              }, {
                feature: '📘 Reflexología energética aplicada',
                base: false,
                pro: true
              }, {
                feature: '📗 Cómo vivir del Reiki (modelo profesional)',
                base: false,
                pro: true
              }, {
                feature: '📙 Aromaterapia terapéutica',
                base: false,
                pro: true
              }, {
                feature: '🎓 Especialización profesional completa',
                base: false,
                pro: true
              }].map((row, idx) => <tr key={idx} className={idx >= 5 ? 'bg-[#d4a017]/[0.03]' : ''} data-id="element-360">
                    <td className="py-3 px-4 md:px-6 text-gray-300 text-xs sm:text-sm" data-id="element-361">
                      {row.feature}
                    </td>
                    <td className="py-3 px-2 md:px-4 text-center" data-id="element-362">
                      {row.base ? <span className="text-green-400 font-bold" data-id="element-363">✔</span> : <span className="text-gray-600" data-id="element-364">—</span>}
                    </td>
                    <td className="py-3 px-2 md:px-4 text-center bg-[#d4a017]/5" data-id="element-365">
                      <span className="text-[#f0c040] font-bold" data-id="element-366">✔</span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        {/* Motivational closing */}
        <div className="mt-8 md:mt-10 text-center max-w-2xl mx-auto space-y-2" data-id="element-367">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-white leading-tight" data-id="element-368">
            Una decisión que puede cambiar tu camino
          </h3>
          <p className="text-gray-300 text-base md:text-lg leading-relaxed" data-id="element-369">
            Podés aprender Reiki… o aprenderlo y convertirlo en una herramienta
            profesional.
          </p>
          <p className="text-[#f0c040] font-serif font-semibold text-lg md:text-xl italic" data-id="element-370">
            La elección es tuya.
          </p>
        </div>

        {/* Social proof + guarantee */}
        <div className="mt-6 text-center space-y-3" data-id="element-371">
          <p className="text-gray-400 text-sm md:text-base font-medium" data-id="element-372">
            🌟 Más de{' '}
            <span className="text-white font-bold" data-id="element-373">1.000 alumnos</span> ya
            comenzaron su formación
          </p>

          <div className="border border-green-500/20 bg-green-500/5 rounded-2xl px-4 sm:px-6 py-4 sm:py-5 max-w-sm mx-auto text-center" data-id="element-374">
            <p className="text-green-400 font-bold text-xs sm:text-sm mb-1" data-id="element-375">
              🔒 Compra protegida por Mercado Pago
            </p>
            <p className="text-white font-semibold text-sm sm:text-base mb-2" data-id="element-376">
              Garantía sin riesgo
            </p>
            <p className="text-gray-400 text-xs sm:text-sm leading-relaxed" data-id="element-377">
              Probalo durante{' '}
              <span className="text-white font-bold" data-id="element-378">7 días</span>. Si sentís
              que no es para vos, te devolvemos el{' '}
              <span className="text-white font-bold" data-id="element-379">100% de tu dinero</span>.
              Sin preguntas. Sin culpa.
            </p>
          </div>

          {/* Payment trust badges */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mt-5 pt-4 border-t border-white/5" data-id="element-380">
            <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-381">
              <span className="text-base" data-id="element-382">🔒</span>
              <span data-id="element-383">Pago seguro con Mercado Pago</span>
            </div>
            <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-384">
              <span className="text-base" data-id="element-385">💳</span>
              <span data-id="element-386">Tarjeta / débito / transferencia</span>
            </div>
            <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-387">
              <span className="text-base" data-id="element-388">📩</span>
              <span data-id="element-389">Acceso inmediato al material</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}